import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Category, CategoryTree, Service } from 'src/app/models/categoryTree/category-tree';
import { Department } from 'src/app/models/department/department';
import { Filter } from 'src/app/models/filters/filters';
import { Label } from 'src/app/models/label/label';
import { AccountService } from 'src/app/services/account/account.service';
import { CalendarService } from 'src/app/services/calendar/calendar.service';
import { CategoriesService } from 'src/app/services/categories/categories.service';
import { DepartmentService } from 'src/app/services/department/department.service';
import { LabelService } from 'src/app/services/label/label.service';

@Component({
  selector: 'app-calendar-filter-details',
  templateUrl: './calendar-filter-details.component.html',
  styleUrls: ['./calendar-filter-details.component.scss'],
})
export class CalendarFilterDetailsComponent implements OnInit {
  id: string;
  filter: Filter = new Filter();

  categoriesSelect = {
    categoryObj0: { categories: [] },
    categoryObj1: { categories: [] },
    categoryObj2: { categories: [] },
    categoryObj3: { categories: [] },
    currentServiceList: [],
  };
  allLabels: Label[] = [];
  allDepartments: Department[];
  categoryTree: CategoryTree;
  allCategories: Category[] = [];
  allServices: Service[] = [];

  constructor(
    private route: ActivatedRoute,
    private calendarService: CalendarService,
    private router: Router,
    public accountService: AccountService,
    private departmentService: DepartmentService,
    private labelService: LabelService,
    private categoriesService: CategoriesService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.id = params.id;
      if (this.id) {
        this.getFilter();
      }
    });

    this.getAllLabels();
    this.getAllDepartments();
    this.getAllCategories();
  }

  getFilter() {
    this.calendarService.getFilter(this.id).subscribe((data) => {
      this.filter = data;
      // if (this.filter.data.categoryroot != null)
      //   this.selectCategory(0);
      // if (this.filter.data.categoryL1 != null)
      //   this.selectCategory(1);
      // if (this.filter.data.categoryL2 != null)
      //   this.selectCategory(2);
      // if (this.filter.data.categoryL3 != null)
      //   this.selectCategory(3);
    });
  }

  saveFilter() {
    if (this.filter === undefined || this.filter.name === undefined || this.filter.name.length <= 0) {
      alert('Errore inserire tutte le informazioni');
    } else {
      if (this.id) {
        this.updateFilter(this.filter);
      } else {
        this.filter.account = this.accountService.vendor;
        this.createFilter(this.filter);
      }
    }
  }

  createFilter(filter) {
    this.calendarService.createFilter(filter).subscribe((data) => {
      this.router.navigate(['calendarFilters']);
    });
  }

  updateFilter(filter) {
    this.calendarService.updateFilter(filter).subscribe((data) => {
      this.router.navigate(['calendarFilters']);
    });
  }

  getAllLabels(): void {
    if (this.accountService.isUser || this.accountService.vendor) {
      this.labelService.getLinkedVendorLabels(this.accountService.vendor).subscribe((data) => {
        this.allLabels = data.labels;
      });
    } else {
      this.labelService.getLabels().subscribe((data) => {
        this.allLabels = data.labels;
      });
    }
  }

  getAllDepartments(): void {
    if (this.accountService.isUser || this.accountService.vendor) {
      this.departmentService.getLinkedVendorDepartments(this.accountService.vendor).subscribe(data => {
        this.allDepartments = data.departments;
      });
    } else {
      this.departmentService.getDepartments().subscribe((data) => {
        this.allDepartments = data.departments;
      });
    }
  }

  getAllCategories(): void {
      this.categoriesService.getVendorTree(this.accountService.vendor).subscribe((data) => {
        this.categoryTree = data;
        this.allCategories = data.categories;
        this.categoriesSelect.categoryObj0 = { ...data };
        // this.newCategoriesSelect = { ...this.categoriesSelect };
        this.exporeCategories(this.allCategories, '');

        for (let x = 0; x <= 4; x++) {
          if (x == 0 && this.filter.data.categoryroot) {
            // this.categoriesSelect['selectedCategory' + x] = this.filter.data.categoryroot;
            this.selectCategory(x);
          } else if (x < 4 && this.filter.data['categoryl' + x]) {
            // this.categoriesSelect['selectedCategory' + x] = this.filter.data['categoryL' + x];
            this.selectCategory(x);
          } else if (x == 4 && this.filter.data.service) {
            // this.categoriesSelect.selectedServiceInList = this.filter.data.service;
          }
        }
      });
  }

  exporeCategories(array, tree): void {
    for (const element of array) {
      if (tree.length > 0) {
        tree = tree.concat(' > ');
      }

      tree = tree.concat(element.title.it);

      this.exporeCategories(element.categories, tree);

      for (const item of element.services) {
        item.tree = tree;
        if (item.deleted == false && item.cartenabled == false && item.visible == true) {
          this.allServices.push(item);
        }

        // if (item.deleted == false && item.cartenabled == true) {
        //   this.cartServices.push(item);
        //   this.cartServicesNotActivated.push(item);
        // }
      }

      const i = tree.lastIndexOf('>');

      tree = tree.substring(0, i - 1);
    }
  }

  selectCategory(currentObj): void {
    this.clearOtherObjects(currentObj);

    if (currentObj != 3) {
      this.categoriesSelect['categoryObj' + (currentObj + 1)] =
        this.categoriesSelect['categoryObj' + currentObj].categories.find(
          (obj) =>
              currentObj == 0 
                ? obj.id == this.filter.data['categoryroot']
                : obj.id == this.filter.data['categoryl' + currentObj]
        );
      this.categoriesSelect.currentServiceList =
        this.categoriesSelect['categoryObj' + (currentObj + 1)].services;
    } else {
      this.categoriesSelect.currentServiceList = this.categoriesSelect[
        'categoryObj' + currentObj
      ].categories.find(
        (obj) =>
          currentObj == 0 
                ? obj.id == this.filter.data['categoryroot']
                : obj.id == this.filter.data['categoryl' + currentObj]
      ).services;
    }
  }

  clearOtherObjects(currentObj): void {
    for (let x = currentObj + 1; x < 4; x++) {
      // this.categoriesSelect['selectedCategory' + x] = undefined;
      this.categoriesSelect['categoryObj' + x] = { categories: [] };
    }

    // this.categoriesSelect.selectedServiceInList = undefined;
    this.categoriesSelect.currentServiceList = [];
  }
}
